import Vue from 'vue'
import { Slide } from 'vue-carousel'
import Carousel from '../../components/core/Carousel'
import initMobileGallery from '../common/initMobileGallery'

$(document).ready(function() {
  initMobileGallery()
})

Vue.component('carousel', Carousel)
Vue.component('v-slide', Slide)

const apps = document.querySelectorAll('.vue-app')

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
